import { gql } from "lib/apolloClient";

export const getGlobalConstantsQuery = gql`
  query getGlobalConstants($id: ID!, $filter: GlobalConstantsFilterOptions) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        globalConstants(filter: $filter) {
          name
          value
          id
        }
      }
    }
  }
`;
